// mobile zooming is done with https://github.com/manuelstofer/pinchzoom

import PinchZoom from 'pinch-zoom-js';
import { isTouch } from '../mobile-detect/mobile-detect';
import {Swiper} from 'swiper';
import getClosest from '../get-closest/get-closest';
export default class RemarkableZoomer {
  _isShown: boolean;
  _selectedIndex: number;
  _totalAlts: number;
  _clientWidth: number;
  _clientHeight: number;
  _lastX: number;
  _lastY: number;
  isDisabled: boolean;
  isZooming: boolean;
  pinchZoomer: PinchZoom;

  _instruction: HTMLDivElement;
  _preloader: HTMLDivElement;
  _leftArrow: HTMLDivElement;
  _rightArrow: HTMLDivElement;
  _menuBar: HTMLDivElement;
  _ZoomCloseBtn: HTMLDivElement;
  _menuBarTitle: HTMLDivElement;
  _footer: HTMLDivElement;
  _footerPagination: string | Node;
  _oneBigImage: HTMLImageElement;
  _oneBigImageContainer: HTMLDivElement;
  _ZoomContainer: HTMLDivElement;
  _altImages: HTMLDivElement;

  _mouseMoveEvent: any;

  constructor() {
    this._isShown = false;
    this._selectedIndex = 0;
    this._totalAlts = 0;
    this._clientWidth = 0;
    this._clientHeight = 0;
    this._lastX = 0;
    this._lastY = 0;
    this.isDisabled = false;
    this.isZooming = false;
    this.pinchZoomer = null;
  }

  initialize() {
    // Setup the close button
    var self = this; /* context */

    // If disabled then don't initialize
    if (self.isDisabled) return;

    // Click indicator
    self._instruction = (() => {
      var tmp = document.createElement('div');
      tmp.className = 'remarkable-zoomer-instruction d-none';
      tmp.innerHTML = 'Click to close';
      return tmp;
    })();

    // Pre-loader
    self._preloader = (() => {
      var tmp = document.createElement('div');
      tmp.className = 'remarkable-zoomer-preload';
      tmp.innerHTML = '<img src="/Content/img/icons/ui/ajax_loader.gif" alt="Loading" height="11" width="43">';
      return tmp;
    })();

    // Left and right arrows
    self._leftArrow = (() => {
      var tmp = document.createElement('div');
      tmp.className = 'btnPrev';
      tmp.addEventListener('mousedown', function (e) {
        e.preventDefault();
        self.prev();
      });
      return tmp;
    })();

    self._rightArrow = (() => {
      var tmp = document.createElement('div');
      tmp.className = 'btnNext';
      tmp.addEventListener('mousedown', function (e) {
        e.preventDefault();
        self.next();
      });
      return tmp;
    })();

    // Close button
    self._menuBar = (() => {
      var tmp = document.createElement('div');
      tmp.classList.add('remarkable-zoomer__options-bar');
      return tmp;
    })();

    self._ZoomCloseBtn = (() => {
      var tmp = document.createElement('div');
      tmp.classList.add('btnZoomerClose');
      tmp.innerHTML = 'X';
      tmp.addEventListener('click', function () {
        self.close();
      });
      return tmp;
    })();

    self._menuBarTitle = (() => {
      var tmp = document.createElement('div');
      tmp.className = 'remarkable-zoomer__options-bar-title';
      tmp.innerHTML = document.querySelector('.product-info__title').innerHTML;
      return tmp;
    })();

    self._menuBar.appendChild(self._ZoomCloseBtn);
    self._menuBar.appendChild(self._menuBarTitle);

    self._footer = (() => {
      var tmp = document.createElement('div');
      tmp.className = 'remarkable-zoomer__footer';
      return tmp;
    })();
    self._footerPagination = (() => {
      var tmp = document.createElement('div');
      tmp.className = 'remarkable-zoomer__footer-pagination';
      tmp.innerHTML = `<span class="remarkable-zoomer__pagination-current">${self._selectedIndex}</span>/<span class="remarkable-zoomer__pagination-total">${self._totalAlts}</span>`;
      return tmp;
    })();

    self._footer.append(self._footerPagination);
    self._footer.appendChild(self._instruction);

    // One big image
    self._oneBigImage = (() => document.createElement('img'))();

    self._bigImageZoomingOff();

    self._mouseMoveEvent = (e: { clientX: any; clientY: any }) => {
      this._lastX = e.clientX;
      this._lastY = e.clientY;
      self.updateImage(this._lastX, this._lastY);
    };

    // Main zoomed image

    self._oneBigImageContainer = (() => {
      var tmp = document.createElement('div');
      tmp.classList.add('remarkable-zoomer__img', 'wm-zoom-box');
      tmp.appendChild(self._oneBigImage);
      if (!isTouch()) {
        tmp.addEventListener('click', function () {
          if (self.isZooming) {
            self._bigImageZoomingOff();
            self._ZoomContainer.removeEventListener('mousemove', self._mouseMoveEvent);
            self._ZoomContainer.removeEventListener('drag', self._mouseMoveEvent);
            self.isZooming = false;
          } else {
            self._bigImageZoomingOn();
            self._ZoomContainer.addEventListener('mousemove', self._mouseMoveEvent);
            self._ZoomContainer.addEventListener('drag', self._mouseMoveEvent);
            self.isZooming = true;
          }
        });
      }
      return tmp;
    })();
    // Alternate images
    self._altImages = ((): HTMLDivElement => {
      var tmp = document.createElement('div');
      tmp.classList.add('zoom-alt');
      return tmp;
    })();

    // Populate it (select the items we want to copy)
    var altImages = document.querySelectorAll('.js-zoomer-image:not(.swiper-slide-duplicate)');

    self._totalAlts = altImages.length;
    altImages.forEach((item, index) => {
      var tmp = item.cloneNode(true) as HTMLElement;

      tmp.classList.remove('product-image__entity');
      tmp.removeAttribute('data-swiper-slide-index');
      var swiperRegex = new RegExp(/\bswiper-slide.*?\b/g);
      tmp.className = tmp.className.replace(swiperRegex, '');
      tmp.removeAttribute('style');
      tmp.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        this._selectedIndex = Number((e.target as HTMLElement).parentElement.getAttribute('data-slide'));
        // Select the image
        this.selectImage(this._altImages.querySelectorAll('div')[this._selectedIndex], false);
        this.updatePagination();
      });
      const img = tmp.querySelector('img');
      if (img) {
        var imgSrc =
          img.getAttribute('data-src') ||
          img.getAttribute('src').replace('medium', 'original').replace('large', 'original');
        img.setAttribute('src', imgSrc);
        img.style.display = 'block';
        img.style.opacity = '1';
      }
      self._altImages.appendChild(tmp);
    });

    // Add the elements to the ZoomContainer
    // The main container
    self._ZoomContainer = (() => {
      var tmp = document.createElement('div');
      tmp.setAttribute('id', 'remarkable-zoomer');
      tmp.style.top = window.scrollY + 'px';
      tmp.appendChild(self._instruction);
      tmp.appendChild(self._preloader);
      tmp.appendChild(self._oneBigImageContainer);
      tmp.appendChild(self._leftArrow);
      tmp.appendChild(self._rightArrow);
      tmp.appendChild(self._menuBar);
      tmp.appendChild(self._footer);
      tmp.appendChild(self._altImages);
      return tmp;
    })();

    // Append to body

    document.querySelector('body').appendChild(self._ZoomContainer);

    window.addEventListener('resize', function () {
      self._resizeImage();
      self.updateImage(this._lastX, this._lastY);
    });

    // Select the first alt image
    self.selectImage(self._altImages.querySelector('.js-zoomer-image:first-child'), true);

    document
      .querySelector('.product-image__main-container')
      .querySelectorAll('.js-zoomer-image')
      .forEach((item) => {
        item.addEventListener('click', function (e) {
          var target = item;
          e.preventDefault();
          var slideIndex = parseInt(target.getAttribute('data-slide'));
          self.selectIndex(slideIndex);
          self.open();
        });
      });

    var zoomerTrigger = document.querySelector<HTMLElement>('.product-image__main-container .js-zoomer-trigger');
    zoomerTrigger?.addEventListener('click', function (e) {
      e.preventDefault();

      var slideIndex = getClosest(zoomerTrigger, '.swiper')!.swiper.realIndex;
      self.selectIndex(slideIndex);
      self.open();
    });
  }

  _bigImageZoomingOn() {
    this._oneBigImage.classList.add('remarkable-zoomer__zoom-on');
    this._oneBigImage.classList.remove('remarkable-zoomer__zoom-off');
  }
  _bigImageZoomingOff() {
    this._oneBigImage.classList.add('remarkable-zoomer__zoom-off');
    this._oneBigImage.classList.remove('remarkable-zoomer__zoom-on');
    this._oneBigImage.style.top = '50%';
  }

  _resizeImage() {
    if (typeof window.innerWidth == 'number') {
      this._clientWidth = window.clientHeight;
      this._clientHeight = window.innerHeight;
    } else {
      if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
        this._clientWidth = document.documentElement.clientWidth;
        this._clientHeight = document.documentElement.clientHeight;
      } else {
        if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
          this._clientWidth = document.body.clientWidth;
          this._clientHeight = document.body.clientHeight;
        }
      }
    }
    this._oneBigImage.style.height = 'auto';
    this._oneBigImage.style.width = this._clientWidth + 'px';
    this._ZoomContainer.style.top = window.scrollY + 'px';
  }

  updateImage(x: any, y: number) {
    var yPercentage = (y / this._clientHeight) * 100;
    var overflowY = parseFloat(getComputedStyle(this._oneBigImage, null).height.replace('px', '')) - this._clientHeight;
    var newY = (overflowY / 100) * yPercentage;
    this._oneBigImage.style.top = -newY + 'px';
  }

  open() {
    if (this._isShown) return;
    document.querySelector('html').classList.add('remarkable-zoomer-visible');
    // Show the instruction box
    this._instruction.classList.add('fade', 'show');

    this._ZoomContainer.style.top = window.scrollY + 'px';

    this._isShown = true;

    // First one
    this._resizeImage();

    // Once initialised make sure the width and height are correct
    this._ZoomContainer.style.height = self._clientHeight + 'px';
    this._ZoomContainer.style.width = self._clientWidth + 'px';

    // Fade it out
    this._instruction.style.display = 'none';

    if (isTouch()) {
      const element = document.querySelector('.remarkable-zoomer__img img') as HTMLElement;
      element.setAttribute('style', '');
      element.classList.remove('remarkable-zoomer__zoom-off', 'remarkable-zoomer__zoom-on');
      if (!this.pinchZoomer) this.pinchZoomer = new PinchZoom(element.parentElement);
      this.pinchZoomer.enable();
      }

      setTimeout(() => {
          document.querySelector<HTMLImageElement>('.remarkable-zoomer__zoom-off')?.click();
      }, 250);
  }

  close() {
    if (!this._isShown) return;
    // this._ZoomContainer.stop(true, true); //.fadeOut('fast');
    this._bigImageZoomingOff();
    this._isShown = false;
    this._ZoomContainer.removeEventListener('mousemove', this._mouseMoveEvent);
    this._ZoomContainer.removeEventListener('drag', this._mouseMoveEvent);

    this.isZooming = false;
    document.querySelector('html').classList.remove('remarkable-zoomer-visible');

    if (isTouch()) this.pinchZoomer.disable();
  }

  setImage(src: string) {
    var self = this; /* context */

    // Show the pre-loader
    self._preloader.style.display = 'block';

    var preloadImage = document.createElement('img');
    preloadImage.onload = function () {
      self._oneBigImage.setAttribute('src', src);
      self._oneBigImage.setAttribute('data-src', src);
      self._resizeImage();
      self._preloader.style.display = 'none';
    };
    preloadImage.src = src;
  }

  selectImage(e: HTMLDivElement, init: boolean) {
    var newIndex = parseInt(e?.getAttribute('data-slide'));

    this._selectedIndex = newIndex;
    this._altImages.querySelectorAll('div').forEach((item) => {
      item.classList.remove('selected');
    });
    e?.classList.add('selected');
    this.setImage(e?.querySelector('img').getAttribute('src'));
    this.updatePagination();
  }

  selectIndex(index: number) {
    if (index >= this._totalAlts) index = this._totalAlts - 1;
    if (index < 0) index = 0;

    this._selectedIndex = index;
    this.updatePagination();
    this._altImages.querySelectorAll('div').forEach((item) => {
      item.classList.remove('selected');
    });
    this._altImages.querySelectorAll(`div`)[index].classList.add('selected');
    this.setImage(this._altImages.querySelectorAll('div')[index].querySelector('img').getAttribute('src'));
  }

  updatePagination() {
    document.querySelector('.remarkable-zoomer__pagination-current').innerHTML = (this._selectedIndex + 1).toString();
    document.querySelector('.remarkable-zoomer__pagination-total').innerHTML = this._totalAlts.toString();
  }

  next() {
    this._selectedIndex++;
    if (this._selectedIndex == this._totalAlts) this._selectedIndex = 0;
    // Select the image
    this.selectImage(this._altImages.querySelectorAll('div')[this._selectedIndex], false);
    this.updatePagination();
  }

  prev() {
    this._selectedIndex--;
    if (this._selectedIndex < 0) this._selectedIndex = this._totalAlts - 1;

    // Select the image
    this.selectImage(this._altImages.querySelectorAll('div')[this._selectedIndex], false);
    this.updatePagination();
  }
}
